import { render } from "./logoAtsiriEat.vue?vue&type=template&id=6a2f8976&scoped=true"
const script = {}

import "./logoAtsiriEat.vue?vue&type=style&index=0&id=6a2f8976&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Lenz\\atsiriBookingApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a2f8976"]])

export default __exports__